var exports = {
  "Qs": "LeaderboardList.module__content___VnZKb1",
  "Ge": "LeaderboardList.module__rows___VnZKb1",
  "nM": "LeaderboardList.module__row___VnZKb1",
  "Cd": "LeaderboardList.module__userButton___VnZKb1",
  "cL": "LeaderboardList.module__userLine___VnZKb1",
  "Tm": "LeaderboardList.module__rank___VnZKb1",
  "UU": "LeaderboardList.module__name___VnZKb1",
  "Al": "LeaderboardList.module__youTag___VnZKb1",
  "JA": "LeaderboardList.module__standing___VnZKb1",
  "RL": "LeaderboardList.module__leagueName___VnZKb1",
  "WR": "LeaderboardList.module__points___VnZKb1",
  "Uq": "LeaderboardList.module__value___VnZKb1",
  "_0": "LeaderboardList.module__detail___VnZKb1",
  "h5": "LeaderboardList.module__status___VnZKb1",
  "qS": "LeaderboardList.module__statusText___VnZKb1",
  "mH": "LeaderboardList.module__centred___VnZKb1",
  "qV": "LeaderboardList.module__skeleton___VnZKb1",
  "US": "LeaderboardList.module__skeletonRow___VnZKb1",
  "sr": "LeaderboardList.module__skeletonRank___VnZKb1",
  "zw": "LeaderboardList.module__skeletonAvatar___VnZKb1",
  "t_": "LeaderboardList.module__skeletonName___VnZKb1",
  "v0": "LeaderboardList.module__skeletonValue___VnZKb1",
  "sM": "LeaderboardList.module__srOnly___VnZKb1",
};

module.exports = exports;
